import React from 'react'
import { FormattedMessage } from 'react-intl'
import zorkitronLogo from 'assets/images/logos/Zorkitron_logo_for_dark_background.png'
import { styles } from './styles.scss'

const Footer = () => {
  return (
    <div className={styles}>
      <div id="footer" className="section">
        <div id="footer-container">
          <img id="footer-logo" src={zorkitronLogo} alt="Notional logo" />
          <div id="footer-lists">
            <ul>
              <li className="heading">
                <FormattedMessage id="landing.section4.column1.heading" />
              </li>
              <li>
                <a href="/deposit">
                  <FormattedMessage id="landing.section4.column1.link1" />
                </a>
              </li>
              <li>
                <a href="/withdraw">
                  <FormattedMessage id="landing.section4.column1.link2" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://docs.zorkitron.com/"
                >
                  <FormattedMessage id="landing.section4.column1.link4" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://docs.zorkitron.com/developers/"
                >
                  <FormattedMessage id="landing.section4.column1.link5" />
                </a>
              </li>
            </ul>
            <ul>
              <li className="heading">
                <FormattedMessage id="landing.section4.column2.heading" />
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://docs.zorkitron.com/"
                >
                  <FormattedMessage id="landing.section4.column2.link1" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://docs.zorkitron.com/governance-parameters"
                >
                  <FormattedMessage id="landing.section4.column2.link2" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://blog.openzeppelin.com/zorkitron-audit/"
                >
                  <FormattedMessage id="landing.section4.column2.link3" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer

